import {
  COLOR_PRIMARY_2_100,
  COLOR_PRIMARY_2_400,
  COLOR_PRIMARY_2_600,
} from 'src/utils/colors';

/** Same as Market Intelligence bar charts (BookingPatternCharts). */
const CALENDAR_COLOR_HIGH = '#0097B2';
/** Very light teal for lowest occupancy – exaggerated so low days read clearly lighter. */
const CALENDAR_COLOR_VERY_LOW = '#E5F2F5';

export const padZero = (num: number): string => {
  return num < 10 ? `0${num}` : num.toString();
};

export const formatDateToYMDString = (date: Date): string => {
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());
  return `${year}-${month}-${day}`;
};

export const generateWeeksForMonth = (year: number, month: number): Date[][] => {
  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);

  const startDayOfWeek = firstDayOfMonth.getDay();
  const startDate = new Date(firstDayOfMonth);
  startDate.setDate(firstDayOfMonth.getDate() - startDayOfWeek);

  const endDayOfWeek = lastDayOfMonth.getDay();
  const endDate = new Date(lastDayOfMonth);
  endDate.setDate(lastDayOfMonth.getDate() + (6 - endDayOfWeek));

  const weeks: Date[][] = [];
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const week: Date[] = [];
    for (let i = 0; i < 7; i++) {
      week.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    weeks.push(week);
  }

  return weeks;
};

export const getOccupancy = (dateStr: string, occupancyMap: Record<string, number>): number => {
  return occupancyMap[dateStr] ?? 0;
};

/**
 * Occupancy → color for Historical Daily Occupancy Calendar.
 * Same PRIMARY_2 / teal scheme as Market Intelligence charts.
 * Exaggerated: low occupancy uses very light tints so low vs high is stark.
 */
export const getColorForOccupancy = (value: number): string => {
  if (value === 0) return '#EEE';
  if (value < 20) return CALENDAR_COLOR_VERY_LOW;
  if (value < 40) return COLOR_PRIMARY_2_100;
  if (value < 60) return COLOR_PRIMARY_2_400;
  if (value < 80) return COLOR_PRIMARY_2_600;
  return CALENDAR_COLOR_HIGH;
};
